import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollRestoration() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Let the browser manage scroll restoration for back/forward/refresh
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'auto'
    }
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
